export default __webpack_public_path__ + "static/4-3c1835c21baac2cad33d70af5f8658d3.jpeg";